module.exports = __webpack_public_path__ + "images/walletprotection27ef40ae116bab88560a9025b5ca917b.jpg";